import React from "react";

import { css } from "glamor";
import glamorous from "glamorous";

var spin = css.keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" }
});

var Spinner = glamorous.div({
  border: "6px solid #f3f3f3",
  borderTop: "6px solid rgba(85, 85, 85, 0.2)",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  animation: spin + " 2s linear infinite"
});

// export const Spinner = (props) => <SpinnerDiv className={styles.Spinner} />

export default Spinner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-common-ui/es/Spinner.js
// module id = 661
// module chunks = 0